import { render, staticRenderFns } from "./BgBlock.vue?vue&type=template&id=6d514c96&comments=true&"
import script from "./BgBlock.vue?vue&type=script&lang=js&"
export * from "./BgBlock.vue?vue&type=script&lang=js&"
import style0 from "./BgBlock.vue?vue&type=style&index=0&id=6d514c96&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports